import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';
import './Layout.css';

function Layout({ children }) {
  const { t } = useLanguage();
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  return (
    <div className="layout">
      <header className="layout-header">
        <Link to="/" className="layout-brand">
          <span className="layout-brand-mark">LIV</span>
          <span className="layout-brand-text">Studio</span>
        </Link>
        <div className="layout-header-end">
          <nav className="layout-nav">
            <Link to="/" className={isHome ? 'active' : ''}>
              {t('nav.home')}
            </Link>
            <Link
              to="/support"
              className={pathname.startsWith('/support') ? 'active' : ''}
            >
              {t('nav.support')}
            </Link>
            <a href="/privacy.html">{t('nav.privacy')}</a>
            <a href="/terms.html">{t('nav.terms')}</a>
          </nav>
          <LanguageSwitcher />
        </div>
      </header>
      <main className={`layout-main${isHome ? ' layout-main--wide' : ''}`}>
        {children}
      </main>
      <footer className="layout-footer">
        <p>© {new Date().getFullYear()} LIV Studio · Ivan Lapshev</p>
        <a href="mailto:livstudiodev@yandex.by">livstudiodev@yandex.by</a>
      </footer>
    </div>
  );
}

export default Layout;
